module.exports = __webpack_public_path__ + "static/008294-9f3f3c4622801f57b903075b42ce15c2.jpg";